import styled from 'styled-components'

const BasicCheckbox = styled.input.attrs({type: 'checkbox'})`
  outline: none;
`

export default BasicCheckbox
